import React from 'react';
import BooklogStoreOrderEditor from "./BooklogStoreOrderEditor";

export default (props) => {
    return <BooklogStoreOrderEditor {...props} in={true} editorContext="BooklogStoreOrderIn"/>;
}